import React, { useState } from 'react';
import {
  collection,
  Timestamp,
  writeBatch,
  doc,
} from 'firebase/firestore';
import { db } from '../firebase';
import {
  Box,
  TextField,
  Button,
  Typography,
  Container,
  Alert,
} from '@mui/material';
import { jsPDF } from 'jspdf';
// Si planeas usar fuentes personalizadas, necesitarás importar sus definiciones.
// Por ejemplo, si usas 'Roboto-Regular-normal.js' y 'Roboto-Bold-normal.js'
// import 'jspdf-autotable'; // Si lo necesitaras, aunque no para este caso
// Esto es para que jsPDF cargue las extensiones de fuentes si las has añadido.
// Si no las tienes como archivos .js pregenerados, usarás las fuentes base.

const generateRandomNumber = () => Math.floor(1000 + Math.random() * 9000);

function AddParticipant() {
  const [username, setUsername] = useState('');
  const [ticketCount, setTicketCount] = useState('');
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const generateMultipleTickets = async (ticketsData) => { // Ahora es async para posibles cargas de fuentes
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'px',
      format: [400, 200], // Tamaño del boleto
    });

    // --- Configuración de Fuentes (ejemplo con Helvetica, pero podrías cargar personalizadas) ---
    // Para usar Google Fonts, necesitarías convertirlas a un formato compatible con jsPDF
    // usando herramientas como 'jspdf-customfonts' o https://raw.githack.com/MrRio/jsPDF/master/fontconverter/
    // Por ahora, usamos las fuentes estándar con estilos.

    // Colores de la paleta (ejemplo: Azul profundo, Dorado, Blanco, Gris oscuro)
    const primaryColor = '#003366'; // Azul marino oscuro
    const accentColor = '#FFD700'; // Dorado
    const textColor = '#FFFFFF';   // Blanco
    const darkTextColor = '#333333'; // Gris muy oscuro para contrastar con blanco
    const highlightColor = '#E74C3C'; // Rojo vibrante para el código

    const currentDate = new Date().toLocaleDateString('es-ES');

    ticketsData.forEach((ticket, i) => {
      const participantName = ticket.username;
      const ticketNumber = ticket.ticket;
      const ticketCode = ticket.code;

      // Fondo principal degradado (simulado con rectángulos de color)
      // jsPDF no tiene un soporte directo para gradientes CSS, así que lo simulamos.
      doc.setFillColor(primaryColor); // Color base
      doc.rect(0, 0, 400, 200, 'F');

      // Un segundo color para simular un degradado o una sección
      doc.setFillColor('#004d99'); // Un azul ligeramente más claro
      doc.rect(0, 0, 400, 100, 'F'); // Mitad superior

      // Borde exterior (opcional, si queremos un "marco")
      doc.setDrawColor(accentColor); // Dorado para el borde
      doc.setLineWidth(4);
      doc.rect(5, 5, 390, 190); // Borde más interno

      // Rectángulo de contenido principal con un color más claro o blanco
      doc.setFillColor(textColor); // Blanco para la zona de contenido
      doc.roundedRect(20, 20, 360, 160, 8, 8, 'F'); // Rectángulo redondeado para el contenido principal

      // Borde interno de la zona de contenido
      doc.setDrawColor(primaryColor); // Azul para el borde interno
      doc.setLineWidth(2);
      doc.roundedRect(20, 20, 360, 160, 8, 8, 'S');

      // --- Título Principal ---
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(24);
      doc.setTextColor(primaryColor); // Azul oscuro
      doc.text('Gran Rifa Consultante', 200, 50, { align: 'center' }); // Título más llamativo

      // --- Subtítulo / Descripción ---
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(14);
      doc.setTextColor(darkTextColor); // Gris oscuro
      doc.text('¡Gana 50,000 pesos!', 200, 70, { align: 'center' });

      // Línea divisoria o elemento gráfico
      doc.setDrawColor(accentColor); // Dorado
      doc.setLineWidth(1);
      doc.line(50, 85, 350, 85);

      // --- Información del Participante ---
      doc.setFont('helvetica', 'normal');
      doc.setFontSize(12);
      doc.setTextColor(darkTextColor);
      doc.text(`Participante:`, 50, 110);
      doc.setFont('helvetica', 'bold'); // Nombre en negrita
      doc.text(`${participantName}`, 120, 110);

      doc.setFont('helvetica', 'normal');
      doc.text(`Boleto Nº:`, 50, 125);
      doc.setFont('helvetica', 'bold');
      doc.text(`${ticketNumber}`, 110, 125);

      doc.setFont('helvetica', 'normal');
      doc.text(`Fecha de Emisión:`, 50, 140);
      doc.setFont('helvetica', 'bold');
      doc.text(`${currentDate}`, 140, 140);

      // --- Código Único (Zona de Destacado) ---
      // Rectángulo de fondo para el código
      doc.setFillColor(primaryColor); // Azul oscuro
      doc.roundedRect(250, 100, 110, 60, 5, 5, 'F');

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(12);
      doc.setTextColor(textColor); // Blanco
      doc.text('CÓDIGO ÚNICO', 305, 115, { align: 'center' });

      doc.setFont('helvetica', 'bold');
      doc.setFontSize(32); // Más grande
      doc.setTextColor(accentColor); // Dorado para el número
      doc.text(`${ticketCode}`, 305, 145, { align: 'center' }); // Centrado en su sección

      // Mensaje de pie de página o instrucciones
      doc.setFont('helvetica', 'italic');
      doc.setFontSize(8);
      doc.setTextColor(darkTextColor);
      doc.text('Presenta este boleto para reclamar tu premio. Válido solo con el código único.', 200, 180, { align: 'center' });


      if (i < ticketsData.length - 1) {
        doc.addPage();
      }
    });

    doc.save(`Boletos_${ticketsData[0].username}.pdf`);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setError('');
    setSuccess('');

    const trimmedUsername = username.trim();
    if (!trimmedUsername || !ticketCount.trim()) {
      setError('Por favor, complete todos los campos.');
      return;
    }

    const count = parseInt(ticketCount, 10);
    if (isNaN(count) || count <= 0) {
      setError('La cantidad de boletos debe ser un número positivo.');
      return;
    }

    setLoading(true);
    const purchaseTime = Timestamp.fromDate(new Date());

    const ticketsData = [];
    for (let i = 0; i < count; i++) {
      ticketsData.push({
        username: trimmedUsername,
        ticket: i + 1,
        purchaseDate: purchaseTime,
        code: generateRandomNumber(),
      });
    }

    try {
      const batch = writeBatch(db);
      const collectionRef = collection(db, 'granRifa');

      ticketsData.forEach((ticket) => {
        const docRef = doc(collectionRef);
        batch.set(docRef, ticket);
      });

      await batch.commit();

      await generateMultipleTickets(ticketsData); // Ahora esperamos por la función

      setSuccess('¡Boletos agregados correctamente!');
      setUsername('');
      setTicketCount('');
    } catch (err) {
      setError('Hubo un error al agregar los boletos o generar el PDF. Inténtelo nuevamente.');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm">
      <Typography
        variant="h5"
        sx={{ textAlign: 'center', fontWeight: 'bold', mt: 4, mb: 2 }}
      >
        Agregar Participante
      </Typography>
      {success && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {success}
        </Alert>
      )}
      {error && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}
      <Box
        component="form"
        onSubmit={handleSubmit}
        sx={{
          mt: 2,
          p: 3,
          border: '1px solid #ccc',
          borderRadius: '8px',
          backgroundColor: '#f9f9f9',
        }}
      >
        <TextField
          label="Nombre de Usuario"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          fullWidth
          required
          sx={{ mb: 2 }}
          disabled={loading}
        />
        <TextField
          label="Cantidad de Boletos"
          value={ticketCount}
          onChange={(e) => setTicketCount(e.target.value)}
          fullWidth
          required
          type="number"
          sx={{ mb: 2 }}
          inputProps={{ min: 1 }}
          disabled={loading}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{
            fontWeight: 'bold',
            padding: '10px 20px',
            mt: 2,
          }}
          disabled={loading}
        >
          {loading ? 'Agregando...' : 'Agregar Boletos'}
        </Button>
      </Box>
    </Container>
  );
}

export default AddParticipant;